import { FetchStatus } from '@powdr/constants';

import { PARKING_PENDING, PARKING_SUCCESS, PARKING_ERROR } from '../types';

const initialState = {
  data: null,
  status: FetchStatus.IDLE,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PARKING_PENDING:
      return {
        ...state,
        status: FetchStatus.LOADING,
      };
    case PARKING_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: FetchStatus.SUCCESS,
      };
    case PARKING_ERROR:
      return {
        status: FetchStatus.ERROR,
        error: action.payload,
      };
    default: return state;
  }
};
